if(!customElements.get('tooltip-component')) {
  class TooltipComponent extends HTMLElement {
    constructor() {
      super();

      this.elParent = this.parentElement;
      this.elParent.addEventListener('mouseenter', () => this.setHovering(true));
      this.elParent.addEventListener('mouseleave', () => this.setHovering(false));
    }

    setHovering(hovering) {
      if(hovering) {
        this.classList.add('visible');
        this.elParent.addEventListener('mousemove', this.setCoordinates.bind(this));
      } else {
        this.classList.remove('visible');
        this.elParent.removeEventListener('mousemove', this.setCoordinates.bind(this));
      }
    }

    setCoordinates(ev) {
      this.style.setProperty('--top', `${ev.clientY}px`);
      this.style.setProperty('--left', `${ev.clientX}px`);
    }

  }

  customElements.define('tooltip-component', TooltipComponent);
}